import type { Finding, ReviewResult } from "./schema.js";

export function renderMarkdown(result: ReviewResult): string {
  const counts = ["critical", "high", "medium", "low"]
    .map((severity) => [severity, result.findings.filter((item) => item.severity === severity).length] as const)
    .filter(([, count]) => count > 0)
    .map(([severity, count]) => `${count} ${severity}`)
    .join(", ");

  const lines = [
    "## Autonomous UI review",
    "",
    `**Result:** ${counts ? `${counts} finding${result.findings.length === 1 ? "" : "s"}` : "No findings"}`,
    "",
    result.summary,
    "",
    "### Coverage",
    "",
    `- ${result.coverage.pagesVisited} pages visited`,
    `- ${result.coverage.interactionsPerformed} interactions performed`,
    `- Viewports: ${result.coverage.viewports.join(", ") || "Not reported"}`,
    `- Areas: ${result.coverage.areasVisited.join(", ") || "Not reported"}`,
  ];

  if (result.findings.length) {
    lines.push("", "### Findings");
    for (const finding of result.findings) lines.push("", ...renderFinding(finding));
  }

  return `${lines.join("\n")}\n`;
}

function renderFinding(finding: Finding): string[] {
  const lines = [
    `#### ${capitalize(finding.severity)} - ${finding.title}`,
    "",
    `**Location:** \`${finding.location}\``,
    "",
    finding.description,
  ];
  if (finding.reproduction.length) {
    lines.push("", "**Reproduction:**", "", ...finding.reproduction.map((step, index) => `${index + 1}. ${step}`));
  }
  if (finding.expected) lines.push("", `**Expected:** ${finding.expected}`);
  if (finding.actual) lines.push("", `**Actual:** ${finding.actual}`);
  if (finding.screenshot) lines.push("", `**Evidence:** \`${finding.screenshot}\``);
  return lines;
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
